import { from, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const parseBlobErrorMessage = async (error: HttpErrorResponse): Promise<string> => {
  if (!(error.error instanceof Blob)) {
    return error.message || 'Something went wrong';
  }

  try {
    const text = await error.error.text();
    const payload = JSON.parse(text);
    return payload?.message || error.message || 'Something went wrong';
  } catch {
    return error.message || 'Something went wrong';
  }
};

const getServerErrorMessage = (error: HttpErrorResponse): string => {
  if (error.error?.message) {
    return error.error.message;
  }

  return `Error Code: ${error.status}\nMessage: ${error.message}`;
};

// Error handling
export function errorHandl(error: HttpErrorResponse) {
  if (error.error instanceof Blob) {
    return from(parseBlobErrorMessage(error)).pipe(
      switchMap((errorMessage) => throwError(() => errorMessage))
    );
  }

  const errorMessage = error.error instanceof ErrorEvent
    ? error.error.message
    : getServerErrorMessage(error);

  return throwError(() => errorMessage);
}
// setting form data
export function setFormData(imgFiles: any, staffData: any, dataRef: any) {
    const formData = new FormData();
    Object.keys(imgFiles).forEach(key => {
            if (imgFiles[key] !== null) {
                formData.append(key, imgFiles[key], imgFiles[key].name);
            }
        });
    Object.keys(staffData).forEach(key => formData.append(`${dataRef}[${key}]`, staffData[key]));
    return formData;
}

// Data Ref. like staff[name] wherein staff is data ref.
export function setFormDataV2(data: any, dataRef?: any) {
    const formData: FormData = new FormData();
    Object.keys(data).forEach((key) => {
        const name = dataRef ? `${dataRef}[${key}]` : key;
        const value = data[key];
        if (value instanceof File) {
            formData.append(key, value, value.name);
        } else if (value instanceof Array) {
            if (value.length) {
                value.forEach(v => {
                    formData.append(name, v);
                });
            } else {
                formData.append(`${name}[]`, '');
            }
        } else {
            formData.append(name, value);
        }
    });
    return formData;
}


export function setOnlyFieldFormData(staffData: any, dataRef: any) {
    const formData = new FormData();
    Object.keys(staffData).forEach(key => formData.append(`${dataRef}[${key}]`, staffData[key]));
    return formData;
}

export function noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      const hasOnlyWhitespace = value.replace(/\s/g, '') === '';
      return hasOnlyWhitespace ? { required: true } : null;
    };
  }
